export const findByStatus = <T extends { status: string }>(
  items: T[],
  status: string[]
): T | undefined => {
  return items.find((item) => status.includes(item.status));
};
